/**
 * Checks whether a template string has a given parameter.
 */
export const hasTemplateParam = (templateString, paramName) => {
    return templateString.includes('${' + paramName + '}');
};
export const appendDisplayTextLabelPart = (label, part) => {
    if (!label)
        return undefined;
    if (Array.isArray(label))
        return [...label, part];
    return [label, part];
};
